import { render } from "./EditCategoryPage.vue?vue&type=template&id=d5ceb5d0"
import script from "./EditCategoryPage.vue?vue&type=script&lang=js"
export * from "./EditCategoryPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__